(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vivelan-listicle"] && !Shopify.designMode) return;
  try {
    
  // Compte à rebours jusqu'à la fin de la journée en cours : l'offre est
  // annoncée « aujourd'hui seulement », le minuteur doit dire la même chose.
  // Pas de remise à zéro artificielle à chaque visite.
  (() => {
    const boxes = document.querySelectorAll('[data-vv-countdown]');
    if (!boxes.length) return;

    const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

    const tick = () => {
      const now = new Date();
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      const left = Math.max(0, Math.floor((end - now) / 1000));

      boxes.forEach((box) => {
        box.querySelector('[data-vv-cd-h]').textContent = pad(Math.floor(left / 3600));
        box.querySelector('[data-vv-cd-m]').textContent = pad(Math.floor((left % 3600) / 60));
        box.querySelector('[data-vv-cd-s]').textContent = pad(left % 60);
      });
    };

    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivelan-merci"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-vv-merci]');
    if (!root || !window.URLSearchParams) return;
    var query = new URLSearchParams(window.location.search);
    var endpoint = '/a/suivi/reponse';
    // Textes traduits rendus par la section (entités HTML décodées).
    var I18N = {};
    try {
      var i18nRaw = JSON.parse(document.getElementById('vv-merci-i18n').textContent);
      var i18nDecoder = document.createElement('textarea');
      for (var i18nKey in i18nRaw) {
        i18nDecoder.innerHTML = i18nRaw[i18nKey];
        I18N[i18nKey] = i18nDecoder.value;
      }
    } catch (e) {}
    var LABELS = ['', I18N.note_1, I18N.note_2, I18N.note_3, I18N.note_4, I18N.note_5];

    var params = {};
    var count = 0;
    query.forEach(function (value, key) {
      if (key === '_kx' || key === 'texte' || key in params || count >= 20) return;
      params[key] = value;
      count++;
    });

    var type = params.type === 'texte' || params.type === 'avis' || params.type === 'clic' ? params.type : params.note ? 'avis' : 'clic';
    if (!params.q) type = 'clic';

    function panel(name) {
      root.querySelectorAll('[data-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-panel') !== name;
      });
      return root.querySelector('[data-panel="' + name + '"]');
    }

    function visible() {
      return document.visibilityState === 'visible' && !document.prerendering;
    }

    // Envoi automatique (réponse en un clic, note du lien) : une fois par lien, page réellement affichée.
    function autoSend(body) {
      var memo = 'vv-merci:' + window.location.search;
      try {
        if (window.sessionStorage.getItem(memo)) return;
      } catch (e) {}
      var sent = false;
      var timer = null;
      function send() {
        if (sent) return;
        sent = true;
        try {
          window.sessionStorage.setItem(memo, '1');
        } catch (e) {}
        var data = JSON.stringify(body);
        var queued = false;
        try {
          queued = !!(navigator.sendBeacon && navigator.sendBeacon(endpoint, new Blob([data], { type: 'text/plain' })));
        } catch (e) {}
        if (!queued) post(body).catch(function () {});
      }
      function arm() {
        if (sent || timer || !visible()) return;
        timer = setTimeout(function () {
          timer = null;
          if (visible()) send();
        }, 1000);
      }
      document.addEventListener('visibilitychange', function () {
        if (!visible() && timer) {
          clearTimeout(timer);
          timer = null;
        }
        arm();
      });
      document.addEventListener('prerenderingchange', arm);
      arm();
    }

    function post(body) {
      return fetch(endpoint, {
        method: 'POST',
        body: JSON.stringify(body),
        keepalive: true,
        credentials: 'same-origin',
        headers: { 'Content-Type': 'text/plain' }
      }).then(function (r) {
        if (!r.ok) throw new Error('envoi ' + r.status);
      });
    }

    function copy(extra) {
      var b = {};
      for (var k in params) b[k] = params[k];
      for (var j in extra) b[j] = extra[j];
      return b;
    }

    // Formulaire texte ou avis : compteur, envoi, confirmation.
    function setupForm(box, build) {
      var form = box.querySelector('[data-form]');
      var area = box.querySelector('[data-texte]');
      var counter = box.querySelector('[data-count]');
      var error = box.querySelector('[data-error]');
      var button = box.querySelector('[data-submit]');
      var label = button.textContent;
      if (params.titre) {
        var title = box.querySelector('[data-question]');
        title.textContent = params.titre.slice(0, 160);
        title.removeAttribute('data-title-noted');
      }
      area.addEventListener('input', function () {
        counter.textContent = String(Array.from(area.value).length);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var body = build(area.value.trim());
        if (typeof body === 'string') {
          error.textContent = body;
          error.hidden = false;
          return;
        }
        error.hidden = true;
        button.disabled = true;
        button.textContent = I18N.sending;
        post(body)
          .then(function () {
            var fin = panel('fin');
            var t = fin.querySelector('[data-fin-title]');
            t.focus();
            window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
          })
          .catch(function () {
            error.textContent = I18N.send_error;
            error.hidden = false;
            button.disabled = false;
            button.textContent = label;
          });
      });
    }

    if (type === 'clic') {
      panel('clic');
      if (params.q) autoSend(params);
      return;
    }

    if (type === 'texte') {
      var boxT = panel('texte');
      setupForm(boxT, function (text) {
        if (!text) return I18N.text_required;
        return copy({ type: 'texte', texte: text });
      });
      return;
    }

    // Avis
    var boxA = panel('avis');
    var stars = Array.prototype.slice.call(boxA.querySelectorAll('[data-note]'));
    var noteLabel = boxA.querySelector('[data-note-label]');
    var note = /^[1-5]$/.test(params.note || '') ? Number(params.note) : 0;
    var recorded = false;

    function paint() {
      stars.forEach(function (s) {
        var n = Number(s.getAttribute('data-note'));
        s.classList.toggle('is-on', n <= note);
        s.setAttribute('aria-checked', String(n === note));
        s.tabIndex = (note ? n === note : n === 1) ? 0 : -1;
      });
      noteLabel.textContent = note ? LABELS[note] : ' ';
    }

    stars.forEach(function (s, i) {
      s.addEventListener('click', function () {
        note = Number(s.getAttribute('data-note'));
        paint();
        boxA.querySelector('[data-error]').hidden = true;
        // Note déjà enregistrée (lien de l'e-mail) : la modification part tout de suite.
        if (recorded) post(copy({ type: 'avis', note: String(note) })).catch(function () {});
      });
      s.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowUp' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowDown' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var j = Math.min(4, Math.max(0, i + d));
        stars[j].focus();
        stars[j].click();
      });
    });

    if (note) {
      // Note choisie dans l'e-mail : titre « Merci pour votre note » et enregistrement immédiat.
      var titleA = boxA.querySelector('[data-question]');
      var intro = boxA.querySelector('[data-avis-intro]');
      if (titleA.hasAttribute('data-title-noted')) titleA.textContent = titleA.getAttribute('data-title-noted');
      intro.textContent = intro.getAttribute('data-intro-noted');
      autoSend(copy({ type: 'avis', note: String(note) }));
      recorded = true;
    }
    paint();

    setupForm(boxA, function (text) {
      if (!note) return I18N.note_required;
      var b = copy({ type: 'avis', note: String(note) });
      if (text) b.texte = text;
      return b;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivelan-questionnaire"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-vv-quiz]');
    if (!root || !window.URLSearchParams) return;
    var endpoint = '/a/suivi/reponse';
    // Textes traduits rendus par la section (entités HTML décodées).
    var I18N = {};
    try {
      var i18nRaw = JSON.parse(document.getElementById('vv-quiz-i18n').textContent);
      var i18nDecoder = document.createElement('textarea');
      for (var i18nKey in i18nRaw) {
        i18nDecoder.innerHTML = i18nRaw[i18nKey];
        I18N[i18nKey] = i18nDecoder.value;
      }
    } catch (e) {}
    var ID = /^[a-z0-9_-]{1,64}$/;
    var query = new URLSearchParams(window.location.search);
    var url = {};
    query.forEach(function (value, key) {
      if (key !== '_kx' && key !== 'texte' && !(key in url)) url[key] = value;
    });
    var produit = url.produit === 'bas' ? 'bas' : 'coussin';
    var questionnaire = /^[a-z0-9_-]{1,40}$/.test(url.questionnaire || '') ? url.questionnaire : root.getAttribute('data-questionnaire');
    var all = Array.prototype.slice.call(root.querySelectorAll('[data-screen="question"]'));
    var questions = all.filter(function (f) {
      var v = f.getAttribute('data-version');
      return v === 'both' || v === produit;
    });
    var ids = questions.map(function (f) { return f.getAttribute('data-id'); });
    var pivot = root.getAttribute('data-pivot') || 'pour_qui';

    // Formulations : la question par défaut est gardée (c'est elle qui est enregistrée) ; les
    // variantes « réponse : formulation » remplacent l'affichage selon la réponse à la question pivot.
    questions.forEach(function (form) {
      var label = form.querySelector('[data-label]');
      label.setAttribute('data-default', label.textContent.trim());
      var variants = {};
      String(form.getAttribute('data-variants') || '').split(/\r?\n/).forEach(function (line) {
        var at = line.indexOf(':');
        if (at < 1) return;
        var key = line.slice(0, at).trim().toLowerCase();
        var text = line.slice(at + 1).trim();
        if (key && text) variants[key] = text;
      });
      form._variants = variants;
    });

    function adapt(value) {
      questions.forEach(function (form) {
        if (form.getAttribute('data-id') === pivot) return;
        var label = form.querySelector('[data-label]');
        label.textContent = (value && form._variants[value]) || label.getAttribute('data-default');
      });
    }
    var screens = Array.prototype.slice.call(root.querySelectorAll('[data-screen]'));
    var memoKey = 'vv-quiz:' + questionnaire + ':' + produit + ':' + (url.p || '');
    var memo = {};
    try {
      memo = JSON.parse(window.sessionStorage.getItem(memoKey) || '{}') || {};
    } catch (e) {}

    function save() {
      try {
        window.sessionStorage.setItem(memoKey, JSON.stringify(memo));
      } catch (e) {}
    }

    function show(el, focusTitle) {
      screens.forEach(function (s) { s.hidden = s !== el; });
      var top = root.getBoundingClientRect().top + window.scrollY - 80;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      var target = el.querySelector('[data-label]') || el.querySelector('[data-fin-title]');
      if (target && focusTitle !== false) {
        target.setAttribute('tabindex', '-1');
        setTimeout(function () { target.focus({ preventScroll: true }); }, 200);
      }
    }

    function post(body) {
      return fetch(endpoint, {
        method: 'POST',
        body: JSON.stringify(body),
        keepalive: true,
        credentials: 'same-origin',
        headers: { 'Content-Type': 'text/plain' }
      }).then(function (r) {
        if (!r.ok) {
          var err = new Error('envoi ' + r.status);
          err.status = r.status;
          throw err;
        }
      });
    }

    // File d'attente des envois : la page n'attend jamais le serveur. Les réponses partent en
    // parallèle, une seule à la fois par question (une réponse plus récente à la même question
    // remplace celle qui attend encore) ; nouvel essai automatique en cas d'échec.
    var queueKey = memoKey + ':file';
    var queue = [];
    try {
      queue = JSON.parse(window.localStorage.getItem(queueKey) || '[]') || [];
    } catch (e) {}
    var inflight = {};
    var tries = {};

    function persist() {
      try {
        if (queue.length) window.localStorage.setItem(queueKey, JSON.stringify(queue));
        else window.localStorage.removeItem(queueKey);
      } catch (e) {}
    }

    function sendOne(body) {
      var q = body.q;
      inflight[q] = body;
      function done() {
        var at = queue.indexOf(body);
        if (at !== -1) queue.splice(at, 1);
        delete inflight[q];
        delete tries[q];
        persist();
        pump();
      }
      post(body)
        .then(done)
        .catch(function (e) {
          // Réponse refusée par le serveur (donnée invalide) : inutile d'insister.
          if (e.status >= 400 && e.status < 500 && e.status !== 429) return done();
          delete inflight[q];
          tries[q] = (tries[q] || 0) + 1;
          if (tries[q] <= 6) setTimeout(pump, Math.min(30000, 1000 * Math.pow(2, tries[q])));
        });
    }

    function pump() {
      queue.forEach(function (body) {
        if (!inflight[body.q]) sendOne(body);
      });
    }

    function enqueue(body) {
      queue = queue.filter(function (b) { return b.q !== body.q || inflight[b.q] === b; });
      queue.push(body);
      persist();
      pump();
    }

    // Fermeture de la page avec des réponses en attente : dernier envoi immédiat.
    window.addEventListener('pagehide', function () {
      if (!queue.length || !navigator.sendBeacon) return;
      queue.forEach(function (b) {
        try {
          navigator.sendBeacon(endpoint, new Blob([JSON.stringify(b)], { type: 'text/plain' }));
        } catch (e) {}
      });
    });

    // Paramètres communs à chaque réponse : ceux du lien (sauf les réponses pré-remplies), plus le contexte.
    function base(extra) {
      var b = {};
      var n = 0;
      for (var k in url) {
        if (ids.indexOf(k) !== -1 || k === 'questionnaire' || k === 'produit' || n >= 10) continue;
        b[k] = String(url[k]).slice(0, 200);
        n++;
      }
      b.questionnaire = questionnaire;
      b.produit = produit;
      for (var j in extra) b[j] = extra[j];
      return b;
    }

    var accord = root.querySelector('[data-accord]');

    function finish() {
      show(root.querySelector('[data-screen="fin"]'));
      if (accord) {
        var aid = accord.getAttribute('data-accord-id') || 'accord_citation';
        var yes = accord.querySelector('[data-accord-box]').checked ? 'oui' : 'non';
        if (memo['r:' + aid] !== yes) {
          memo['r:' + aid] = yes;
          save();
          enqueue(base({ q: questionnaire + '-' + aid, type: 'clic', r: yes }));
        }
      }
      if (!memo.termine) {
        memo.termine = true;
        save();
        enqueue(base({ q: questionnaire + '-termine', type: 'clic', r: 'oui' }));
      }
    }

    function go(i) {
      if (i < 0) return;
      if (i >= questions.length) finish();
      else show(questions[i]);
    }

    // Enregistre une réponse (en arrière-plan). Réponse identique à la précédente : rien n'est renvoyé.
    function answer(i, kind, value) {
      var form = questions[i];
      var id = ids[i];
      var key = kind === 'texte' ? 't:' + id : 'r:' + id;
      if (memo[key] === value && memo['ok:' + id]) return;
      var body = base({ q: questionnaire + '-' + id, type: kind, ordre: String(i + 1), libelle: form.querySelector('[data-label]').getAttribute('data-default').slice(0, 200) });
      if (kind === 'texte') body.texte = value;
      else body.r = value;
      memo[key] = value;
      memo['ok:' + id] = true;
      save();
      enqueue(body);
    }

    function fail(form, text) {
      var error = form.querySelector('[data-error]');
      error.textContent = text;
      error.hidden = false;
    }

    questions.forEach(function (form, i) {
      var type = form.getAttribute('data-type');
      var required = form.getAttribute('data-required') === 'true';
      var error = form.querySelector('[data-error]');
      var choices = Array.prototype.slice.call(form.querySelectorAll('[data-value]'));
      var next = form.querySelector('[data-next]');
      var id = ids[i];

      form.querySelector('[data-step]').textContent = I18N.step.replace('[current]', i + 1).replace('[total]', questions.length);
      form.querySelector('[data-bar]').style.width = Math.round(((i + 1) / questions.length) * 100) + '%';
      if (next) next.textContent = i === questions.length - 1 ? next.getAttribute('data-label-last') : next.getAttribute('data-label-next');
      var prev = form.querySelector('[data-prev]');
      if (i === 0) prev.hidden = true;
      prev.addEventListener('click', function () { go(i - 1); });
      var skip = form.querySelector('[data-skip]');
      if (skip) skip.addEventListener('click', function () { go(i + 1); });

      function pressed() {
        return choices.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; }).map(function (c) { return c.getAttribute('data-value'); });
      }

      function restore() {
        var saved = memo['r:' + id];
        if (!saved) return;
        var list = String(saved).split(',');
        choices.forEach(function (c) { c.setAttribute('aria-pressed', String(list.indexOf(c.getAttribute('data-value')) !== -1)); });
      }
      restore();

      if (type === 'unique') {
        choices.forEach(function (c) {
          c.addEventListener('click', function () {
            if (form.hidden) return;
            choices.forEach(function (o) { o.setAttribute('aria-pressed', String(o === c)); });
            error.hidden = true;
            if (id === pivot) adapt(c.getAttribute('data-value'));
            answer(i, 'clic', c.getAttribute('data-value'));
            // Court délai pour voir son choix s'allumer, puis question suivante.
            setTimeout(function () { if (!form.hidden) go(i + 1); }, 250);
          });
        });
      } else if (type === 'multiple') {
        choices.forEach(function (c) {
          c.addEventListener('click', function () {
            c.setAttribute('aria-pressed', String(c.getAttribute('aria-pressed') !== 'true'));
            error.hidden = true;
          });
        });
      } else {
        var input = form.querySelector('[data-texte]');
        if (memo['t:' + id]) input.value = memo['t:' + id];
        input.addEventListener('input', function () { error.hidden = true; });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (type === 'unique') return;
        var value = type === 'multiple' ? pressed().sort().join(',') : form.querySelector('[data-texte]').value.trim();
        if (!value) {
          if (required) fail(form, type === 'multiple' ? I18N.error_multiple : I18N.error_text);
          else go(i + 1);
          return;
        }
        answer(i, type === 'multiple' ? 'multi' : 'texte', value);
        go(i + 1);
      });
    });

    var start = root.querySelector('[data-start]');
    if (start && questions.length) start.addEventListener('click', function () { go(0); });

    // Case d'accord : sur la dernière question, juste avant le bouton d'envoi.
    if (accord && questions.length) {
      var lastForm = questions[questions.length - 1];
      var anchor = lastForm.querySelector('[data-next]') || lastForm.querySelector('[data-skip]') || lastForm.querySelector('.vv-quiz__nav');
      anchor.parentNode.insertBefore(accord, anchor);
      accord.hidden = false;
      var aidSaved = memo['r:' + (accord.getAttribute('data-accord-id') || 'accord_citation')];
      if (aidSaved) accord.querySelector('[data-accord-box]').checked = aidSaved === 'oui';
    }

    // Réponses restées en attente lors d'une visite précédente : envoyées maintenant.
    pump();

    // Réponse à la question pivot déjà donnée (page rechargée) : formulations adaptées tout de suite.
    if (memo['r:' + pivot]) adapt(memo['r:' + pivot]);

    // Réponses venues du lien (ex. pour_qui=moi cliqué dans l'e-mail) : enregistrées une fois la
    // page réellement affichée, puis ouverture directe de la première question sans réponse.
    var prefilled = [];
    questions.forEach(function (form, i) {
      var raw = url[ids[i]];
      if (!raw || form.getAttribute('data-type') === 'texte') return;
      var allowed = Array.prototype.map.call(form.querySelectorAll('[data-value]'), function (c) { return c.getAttribute('data-value'); });
      var list = String(raw).toLowerCase().split(',').filter(function (v) { return ID.test(v) && allowed.indexOf(v) !== -1; });
      if (!list.length) return;
      if (form.getAttribute('data-type') === 'unique') list = list.slice(0, 1);
      Array.prototype.forEach.call(form.querySelectorAll('[data-value]'), function (c) {
        c.setAttribute('aria-pressed', String(list.indexOf(c.getAttribute('data-value')) !== -1));
      });
      prefilled.push({ i: i, kind: form.getAttribute('data-type') === 'multiple' ? 'multi' : 'clic', value: list.sort().join(',') });
      if (ids[i] === pivot) adapt(list[0]);
    });

    if (!prefilled.length) return;
    var firstOpen = 0;
    while (firstOpen < questions.length && prefilled.some(function (p) { return p.i === firstOpen; })) firstOpen++;
    go(firstOpen);

    var sent = false;
    var timer = null;
    function visible() {
      return document.visibilityState === 'visible' && !document.prerendering;
    }
    function send() {
      if (sent) return;
      sent = true;
      prefilled.forEach(function (p) { answer(p.i, p.kind, p.value); });
    }
    function arm() {
      if (sent || timer || !visible()) return;
      timer = setTimeout(function () {
        timer = null;
        if (visible()) send();
      }, 1000);
    }
    document.addEventListener('visibilitychange', function () {
      if (!visible() && timer) {
        clearTimeout(timer);
        timer = null;
      }
      arm();
    });
    document.addEventListener('prerenderingchange', arm);
    arm();
  })();

  } catch(e) { console.error(e); }
})();
})();
